<template>
  <div class="hb-page-nav" :style="outerStyle">
    <div class="nav-inner">
      <div class="base-wrapper" :style="baseStyle">
        <slot name="base">
          <div class="text" v-if="text && !isUseOver" :style="textStyle">{{ text }}</div>
        </slot>
      </div>
      <div class="over-wrapper" v-if="isUseOver">
        <slot name="over">
          <div class="text" v-if="text" :style="textStyle">{{ text }}</div>
          <heyboxLogo :logo-color="logoColor" v-else></heyboxLogo>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import { executeProtocolSync, isInHeybox, getUrlParam } from '_lib/utils'
import heyboxLogo from './components/heybox-logo.vue'
export default {
  name: 'PageNav',
  components: {
    heyboxLogo,
  },
  props: {
    bg: {
      type: String,
      required: true,
      default: '#fff',
    },
    logoColor: {
      type: String,
      default: 'rgba(255, 255, 255, 0.8)',
    },
    text: {
      type: String,
    },
    isUseOver: {
      type: Boolean,
      default: true,
    },
    textColor: {
      type: String,
      default: '#000',
    },
    scrollDomSelector: {
      type: String,
      default: 'window',
    },
    isUseListener: {
      type: Boolean,
      default: true,
    },
    startDistance: {
      type: Number,
      default: 20,
    },
    endDistance: {
      type: Number,
      default: 52,
    },
    isFixed: {
      type: Boolean,
      default: false,
    },
    inputHeight: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      baseOpacity: 0,
      scrollDom: null,
      navHeight: this.initNavHeight()
    }
  },
  computed: {
    baseStyle() {
      return {
        background: this.bg,
        opacity: this.baseOpacity,
        height: this.navHeight + 'px'
      }
    },
    textStyle() {
      return {
        color: this.textColor
      }
    },
    outerStyle() {
      return {
        height: `${this.isFixed ? 0 : this.navHeight}px`,
      }
    },
  },
  mounted() {
    if (this.isUseListener) {
      this.setScrollListener()
    } else {
      this.baseOpacity = 1
    }
  },
  methods: {
    initNavHeight () {
      if (this.inputHeight == -1) {
        if (this.$nav_height) {
          return this.$nav_height
        } else {
          return Number(executeProtocolSync({
            "protocol_type": "getNavigationBarHeight"
          }))
        }
      } else {
        return this.inputHeight
      }
    },
    setScrollListener() {
      this.scrollDom = this.scrollDomSelector == 'window' ? window : document.querySelector(this.scrollDomSelector)
      if (this.scrollDom) {
        this.scrollDom.addEventListener('scroll', this.updateBaseOpacity)
      } else {
        console.error('scrollDomSelector is not exist')
      }
    },
    updateBaseOpacity() {
      const scrollHeight = this.scrollDomSelector === 'window' ? window.scrollY : this.scrollDom.scrollTop
      if (scrollHeight < this.startDistance) {
        this.baseOpacity = 0
      } else if (scrollHeight < this.endDistance) {
        this.baseOpacity = (scrollHeight - this.startDistance) / (this.endDistance - this.startDistance)
      } else {
        this.baseOpacity = 1
      }
    }
  },
  install (Vue) {
    Vue.prototype.$nav_height = Number(executeProtocolSync({
      "protocol_type": "getNavigationBarHeight"
    }))
    Vue.component(this.name, this)
  }
}

</script>

<style lang="less" scoped>
.hb-page-nav {
  position: relative;
  z-index: 1000;

  .nav-inner {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;

    .base-wrapper {
      width: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      padding-bottom: 13px;
    }

    .over-wrapper {
      position: absolute;
      left: 50%;
      bottom: 13px;
      width: fit-content;
      pointer-events: none;
      transform: translateX(-50%);
    }

    .base-wrapper,
    .over-wrapper {
      .text {
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        letter-spacing: 0.25px;
      }
    }
  }
}
</style>